import React from 'react';
import { MapPin, Droplets, Sparkles, Star } from 'lucide-react';
export function WhyCapstone() {
  const features = [{
    icon: <MapPin className="w-8 h-8 text-[#7FD4D4]" data-id="element-279" />,
    title: 'We Come to You',
    description: 'Home, office, or anywhere in the valley. We bring our own power and supplies.'
  }, {
    icon: <Droplets className="w-8 h-8 text-[#7FD4D4]" data-id="element-280" />,
    title: 'Waterless & Eco-Friendly',
    description: 'Advanced polymer technology that cleans, shines, and protects without the mess.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-[#7FD4D4]" data-id="element-281" />,
    title: 'Premium Products Only',
    description: 'We use only professional-grade compounds, polishes, and ceramic coatings.'
  }, {
    icon: <Star className="w-8 h-8 text-[#7FD4D4]" data-id="element-282" />,
    title: '5-Star Rated',
    description: 'Hundreds of satisfied customers across Phoenix trust us with their vehicles.'
  }];
  return <section className="py-20 md:py-32 bg-[#222222]" data-id="element-283">
      <div className="container mx-auto px-4 md:px-6" data-id="element-284">
        <div className="text-center mb-16" data-id="element-285">
          <span className="text-[#7FD4D4] font-bold tracking-[0.2em] text-sm uppercase block mb-4" data-id="element-286">
            The Capstone Difference
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase" data-id="element-287">
            Why Phoenix Trusts Capstone
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-288">
          {features.map((feature, index) => <div key={index} className="bg-[#1A1A1A] p-8 border border-white/5 rounded-sm flex flex-col items-start h-full" data-id="element-289">
              <div className="bg-[#111111] p-4 rounded-full mb-6 border border-white/10" data-id="element-290">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-montserrat" data-id="element-291">
                {feature.title}
              </h3>
              <p className="text-white/70 leading-relaxed font-inter" data-id="element-292">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}